// extracted by mini-css-extract-plugin
module.exports = {"checkbox_container":"checkbox_checkbox_container__36j4q","checkmark":"checkbox_checkmark__3XZR-","checkmark_icon":"checkbox_checkmark_icon__1IlDQ"};